import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for autoexclusion users in a record table.
 * @extends JetView
 */
export default class recordTableAutoexclusionUsersView extends JetView {
    /**
     * Configures the datatable layout and properties.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type as datatable
            columns: [
                // Defines the columns of the datatable
                {
                    id: 'Reason', // Unique identifier for the column
                    header: _('Motivo Autoexclusión'), // Header text with localization
                    width: 250, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Notes', // Unique identifier for the column
                    header: _('Notas Modificación'), // Header text with localization
                    width: 250, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager configuration
            // API endpoint for fetching data
            url: devConfig.geturlApi() + 'null/Report/getRegisteredAutoexclusion',
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        let url = grid.data.url; // Store the URL for data loading
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID changes
            grid.clearAll(); // Clears the current data in the grid
            grid.load(url + '?Id=' + idUser); // Loads new data based on the user ID
        });
    }
}

// FILE DOCUMENTED
